import { CCUtils } from "../../../../common/CCUtils"
import { Sprites } from "../../../utils/Sprites"
import { WomImage } from "../WheelOfMisfortuneAssets"

export class ArrowSprite {
    arrow: Phaser.Sprite
    private rotationUp: Phaser.Tween
    private rotationDown: Phaser.Tween

    constructor(game: Phaser.Game) {
        this.arrow = Sprites.add(game, WomImage.ARROW, {
            debug: CCUtils.debug,
            scale: 0.3
        })
        this.rotationUp = game.add.tween(this.arrow).to({angle: -90}, 1000, Phaser.Easing.Quadratic.Out)
        this.rotationDown = game.add.tween(this.arrow).to({angle: 0}, 1000, Phaser.Easing.Quadratic.Out)
        this.arrow.anchor.set(0.5, 0.5)
    }

    rotateUp = () => this.rotationUp.start()

    rotateDown = (onStop?: () => void) => {
        if (onStop !== undefined) {
            this.rotationDown.onComplete.addOnce(onStop)
        }

        this.rotationDown.start()
    }

    hide = () => this.arrow.visible = false

    view = () => this.arrow.visible = true
}